<template>
  <my-giving-layout :enable-scroll-event="true">
    <div class="bg-[#F6F4F0] font-inter">
      <BackButton class="w-full px-[20px]" :customBack="back" />
    </div>
    <div class="px-[20px] mt-[32px]">
      <p class="font-black text-[2rem] tracking-[-0.03em]">Taking your first step to tithe?</p>
      <div class="flex flex-col justify-evenly mb-[40px]">
        <p class="mt-[32px]">
          Tithing is an act of obedience, and a way to express our gratitude to God. &#128512;
        </p>
        <div
          class="rounded-2xl bg-[#FFFFFF] mt-[24px] px-[15px] py-[20px] flex flex-col items-center"
        >
          <p class="mb-[12px] text-center">
            "A tithe of everything from the land... belongs to the Lord; it is holy to the Lord."
          </p>
          <p class="font-bold">Leviticus 27:30</p>
        </div>
        <span class="mt-[24px]">
          This is also an opportunity to encounter God, and we're cheering you on as you step out in
          faith!
        </span>
        <div
          class="rounded-2xl bg-[#FFFFFF] mt-[24px] px-[15px] py-[20px] flex flex-col items-center"
        >
          <p class="font-bold text-sm">90% with God is better than</p>
          <p class="font-bold text-sm">100% without Him</p>
          <img
            src="/assets/images/my-giving/tithe/tithe-90-100.webp"
            alt="90% with God is better than 100% without Him"
          />
        </div>
        <GiveNowButton class="mt-[64px]" />
        <p class="italic text-[0.875rem] mt-[16px] mb-[48px]">
          If you have already given your tithe, please allow 7 - 14 days for it to reflect in your
          history
        </p>
      </div>
    </div>
  </my-giving-layout>
</template>

<script>
import MasterLayout from '@/components/MasterLayout.vue';
import BackButton from '@/components/common/BackButton.vue';
import GiveNowButton from '@/components/MyGiving/Common/GiveNowButton.vue';
import MyGivingLayout from '@/components/MyGivingLayout.vue';

export default {
  components: {
    MasterLayout,
    BackButton,
    GiveNowButton,
    MyGivingLayout,
  },
  methods: {
    back() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace('/my-giving');
      }
    },
    gotoMyGiving() {
      this.$router.push('/my-giving/giving-options');
    },
  },
};
</script>
